module.exports = __webpack_public_path__ + "img/nature12.d30a804d.jpg";